import React from "react";
import {connect} from "react-redux";
import {Dimensions, FlatList, ScrollView, Text, View} from "react-native";
import PostFeed from "./PostFeed";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

class PostList extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            page : 0,
            data : this.props.data,
            isRefresh : false,
        }
        this.data = this.props.data;
    }
    _refresh(){
        this.setState({
           isRefresh:true,
           data : ()=>{this.props.refresh()}
        });
    }

    componentDidUpdate() {
        this.data = this.props.data;
    }

    render() {
        // avoid at render...
        const {width,height} = Dimensions.get('window');
        const renderEmpty= (item) =>{
                return <View style={{width: width, height: height-202, justifyContent: "center", alignItems: "center"}}>
                    <Text style={{color : this.props.theme.colors.tertiary.black1.value,fontFamily:this.props.theme.fonts.text}}>{this.props.t('Aucun élément à afficher')}</Text>
                </View>
        }

        const style = {
          width: "100vw",
          flex:1,
          flexDirection:"column",
          maxHeight: this.props.isProfile ? height : (this.props.isExplorer ? height - 287 : height - 202),
          flexGrow: 1
        };

        return (

            <FlatList
                ListHeaderComponent={this.props.header}
                refreshing={this.state.isRefresh}
                onRefresh={()=>{this._refresh();this.setState({isRefresh:false})}}
                style={style}
                contentContainerStyle={{flex:1,}}
                data={this.props.data}
                onEndReachedThreshold={1}
                onEndReached={()=>{this.props.loadMore();}}
                keyExtractor={(item)=>{ return item.id;}}
                ListEmptyComponent={renderEmpty}
                renderItem={(item) =>{
                    return <PostFeed post={item} bookmark={this.props.bookmark} isExplorer={this.props.isExplorer}
                            isPost={false} refNavigation={this.props.refNavigation} route={this.props.route} />
                }}
        />

        );

    }

}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme, auth : state.AuthReducer};
}

export default compose(withTranslation(),connect(mapStateToProps))(PostList);
